import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchFromOldApi } from '~/services/Http';

import { CostCenter } from './types';

export type StoreState = {
  costCenters: CostCenter[];
  hasData: boolean;
  isLoading: boolean;
  failedToLoad: boolean;
};

const initialState: StoreState = {
  costCenters: [],
  hasData: false,
  isLoading: false,
  failedToLoad: false,
};

export enum CostCenterActionKeyPrefixes {
  FETCH_COSTCENTERS = 'costCenters/FETCH_COSTCENTERS',
}

export type CostCenterPayload = {
  costCenters: CostCenter[];
};

const getCostCenters = async (): Promise<CostCenter[]> =>
  await fetchFromOldApi(`/json/costcenter?includeInactive=false`).then((r) =>
    r.json(),
  );

export const fetchCostCenters = createAsyncThunk<CostCenterPayload, undefined>(
  CostCenterActionKeyPrefixes.FETCH_COSTCENTERS,
  async (): Promise<CostCenterPayload> => {
    return {
      costCenters: await getCostCenters(),
    };
  },
);

export const costCenterSlice = createSlice({
  name: '~/data/costCenters',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCostCenters.fulfilled.type]: (
      state: StoreState,
      action: PayloadAction<CostCenterPayload>,
    ) => {
      state.failedToLoad = false;
      state.isLoading = false;
      state.hasData = true;
      state.costCenters = action.payload.costCenters;
    },
    [fetchCostCenters.pending.type]: (state: StoreState) => {
      state.isLoading = true;
    },
    [fetchCostCenters.rejected.type]: (state: StoreState) => {
      state.failedToLoad = true;
    },
  },
});

export const costCenterReducer = costCenterSlice.reducer;
